import _ from 'lodash'
import Backbone from 'backbone'
import template from './new-briefing-form.hbs'
import FormView from 'scoreboard/components/form-view'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'

/**
 * This form is only available when clicking on the Add button inside the add
 * briefing book slide dialog.
 */
var NewBriefingForm = Backbone.View.extend({

	tagName: 'form',

	className: 'new-briefing-form',

	initialize: function() {
		this.formView = new FormView({ el: this.el, submit: this.submit.bind(this) })
	},

	render: function() {
		this.$el.empty().append(template())
		this.labelField = new MarkedField({
			el: this.$('[name=label]'),
			validator: requiredValidator
		}).render()

		this.formView.start()
		return this
	},

	submit: function(e) {
		e.preventDefault()

		var data = { label: _.trim(this.$('[name=label]').val()) }
		return this.model.save(data, {
			success: function(model) {
				// note: trigger the done first because there are other things
				// that are listening to add:domain-object that it's impossible
				// to execute code before.  if you want something after
				// add:domain-object, you can listen for that.  if you want
				// something before instead, you can listen for done.  this was
				// important for #7781 and the listeners in
				// new-slide-form.js:addBriefing
				this.trigger('done', model)
				Backbone.trigger('add:domain-object', model, model.get('relativeId'))
			}.bind(this)
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.labelField, this.formView], 'remove')
	}

})

export default NewBriefingForm

NewBriefingForm.__filename__ = 'briefings/new-briefing-form.js'
